// src/pages/RideDocuments.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_WRK = process.env.REACT_APP_API_WRK;
// Derive API host (e.g., http://localhost:5000) from http://.../api/worker
const API_HOST = API_WRK?.replace(/\/api\/worker\/?$/, "") || window.location.origin;

const RideDocuments = () => {
  const [worker, setWorker] = useState(null);
  const navigate = useNavigate();
  const workerId = localStorage.getItem("workerId");

  useEffect(() => {
    const fetchWorker = async () => {
      try {
        const res = await axios.get(`${API_WRK}/profile/${workerId}`);
        setWorker(res.data);
      } catch (err) {
        console.error("Error fetching worker profile:", err);
      }
    };
    if (workerId) fetchWorker();
  }, [workerId]);

  if (!worker) return <div className="p-6">Loading...</div>;

  const rideDocs = worker.driverProfile;

  const getStatus = (status) => {
    if (status === "approved")
      return <span className="text-green-600 font-medium text-sm">✅ Approved</span>;
    if (status === "rejected")
      return <span className="text-red-600 font-medium text-sm">❌ Rejected</span>;
    return <span className="text-yellow-600 font-medium text-sm">⏳ Pending</span>;
  };

  return (
    <div className="min-h-screen p-4 bg-gray-50 text-gray-800">
      <h1 className="text-xl font-bold mb-6 text-center text-black">🚗 Ride Documents</h1>

      {!rideDocs ? (
        <div className="bg-white p-6 rounded shadow text-center">
          <p className="text-gray-600 text-sm mb-2">
            You haven’t uploaded your ride documents yet.
          </p>
          <button
            onClick={() => navigate("/driver-setup")}
            className="mt-2 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Go to Earn with Rides
          </button>
        </div>
      ) : (
        <div className="space-y-4">
          {/* Car Photo - Can re-upload only if Approved */}
          <div
            className={`bg-white rounded-lg p-4 shadow-sm flex justify-between items-center ${
              rideDocs.carStatus === "approved" ? "cursor-pointer" : ""
            }`}
            onClick={() => {
              if (rideDocs.carStatus === "approved") {
                navigate("/driver-setup");
              }
            }}
          >
            <div>
              <p className="font-semibold text-base">Car Photo</p>
              {rideDocs.carStatus === "approved" ? (
                <p className="text-sm text-blue-600 underline">
                  Click to re-upload or change
                </p>
              ) : (
                <p className="text-sm text-gray-500">Uploaded</p>
              )}
            </div>
            {getStatus(rideDocs.carStatus)}
          </div>

          {/* Driver's License - Locked */}
          <div className="bg-white rounded-lg p-4 shadow-sm flex justify-between items-center">
            <div>
              <p className="font-semibold text-base">Driver's License</p>
              <p className="text-sm text-gray-500">Uploaded</p>
            </div>
            {getStatus(rideDocs.licenseStatus)}
          </div>

          {/* Insurance - Locked */}
          <div className="bg-white rounded-lg p-4 shadow-sm flex justify-between items-center">
            <div>
              <p className="font-semibold text-base">Insurance</p>
              <p className="text-sm text-gray-500">Uploaded</p>
            </div>
            {getStatus(rideDocs.insuranceStatus)}
          </div>
        </div>
      )}
    </div>
  );
};

export default RideDocuments;
